
import React from 'react';
import Layout from '@/components/Layout/Layout';
import RetirementCalculator from '@/components/SpecialCalculators/FinancialCalculators/RetirementCalculator';
import { Link } from 'react-router-dom';

const RetirementCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4">
        {/* Header Section */}
        <div className="mb-8">
          <div className="text-sm text-gray-500 mb-2">
            <Link to="/" className="hover:underline">Home</Link> {' > '} 
            <Link to="/special" className="hover:underline">Special Tools</Link> {' > '} 
            <span>Retirement Calculator</span>
          </div>
          <h1 className="text-3xl font-bold mb-3">Retirement Calculator</h1>
          <p className="text-gray-700">
            Plan for your retirement, calculate how much you need to save, and see if you're on track to meet your retirement goals.
          </p>
        </div>

        {/* Calculator Section */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-8">
          <RetirementCalculator />
        </div>

        {/* Information Section */}
        <div className="bg-[#E6F3FF] p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-semibold mb-3">How to use the Retirement Calculator</h2>
          <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-2">
            <li>Enter your current age and desired retirement age</li>
            <li>Set your life expectancy to determine how long your savings need to last</li>
            <li>Enter your current retirement savings and monthly contribution</li>
            <li>Input your expected annual return on investments and inflation rate</li>
            <li>Specify your desired annual retirement income</li>
            <li>The calculator will show if you're on track and any adjustments needed</li>
          </ol>
        </div>

        {/* Additional Information */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">About Retirement Planning</h2>
          <p className="text-gray-700 mb-3">
            Retirement planning involves determining how much money you need to save today to support your desired lifestyle 
            after you stop working. A common rule of thumb is the 4% rule, which suggests that retirees can withdraw 4% of their 
            initial retirement savings each year (adjusted for inflation) with minimal risk of running out of money over a 30-year retirement.
          </p>
          <p className="text-gray-700 mb-3">
            Inflation is a critical factor in retirement planning as it erodes purchasing power over time. Even a modest 
            inflation rate of 2-3% can significantly impact your needed savings over a 20-30 year retirement period.
          </p>
          <p className="text-gray-700 mb-3">
            Starting early is one of the most important aspects of retirement planning. Due to compound interest, money saved 
            in your 20s and 30s can have a much greater impact than larger amounts saved later in life. Even small increases 
            in your savings rate can make a substantial difference in your final retirement balance.
          </p>
        </div>

        {/* Related Calculators */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">Related Calculators</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Link to="/special/investment" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">📈</span> Investment Calculator
            </Link>
            <Link to="/special/interest" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">💲</span> Interest Calculator
            </Link>
            <Link to="/special/salary" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">💼</span> Salary Calculator
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RetirementCalculatorPage;
